import { useTIWStore } from "@/stores/tiw/tiw";

export function widgetScrollToTop(position: number = 0, behavior: ScrollBehavior = "smooth"): void {
    const TIWStore = useTIWStore();
    const root_element: string = TIWStore.INJECTED_TIW.current_settings.root_element;
    const wrapper: HTMLElement | null = document.querySelector(
        `.tiw[root_element="${root_element}"] > .tiw__wrapper`,
    );

    if (!wrapper) return;

    wrapper.scrollTo({
        top: position,
        behavior,
    });
}

/** Проскроллить страницу хоста до верха виджета (актуально для embed режима, где виджет встроен в поток страницы) */
export function scrollHostPageToWidgetTop(
    rootElementId: string,
    behavior: ScrollBehavior = "smooth",
): void {
    const hostElement: HTMLElement | null = document.getElementById(rootElementId);

    if (!hostElement) return;

    hostElement.scrollIntoView({ behavior, block: "start" });
}
